import { createModuleExtension } from '@wix/premium-fed-sdk/@premium-module';
import { CoreDomainSearchModule, useInViewOnce } from '@wix/core-domain-search';
const IMPRESSION_THRESHOLD = 0.5;
export const suggestionImpressionsExtension = createModuleExtension(hostModule => ({
  extensionName: 'suggestionImpressionReporter',
  SDK: {
    useSuggestionImpression: _ref => {
      var _CoreDomainSearchModu;
      let domain = _ref.domain,
        position = _ref.position,
        pageNumber = _ref.pageNumber,
        isPremium = _ref.isPremium,
        _ref$enabled = _ref.enabled,
        enabled = _ref$enabled === void 0 ? true : _ref$enabled;
      const searchKey = (_CoreDomainSearchModu = CoreDomainSearchModule.SDK.domainInputStore.useSubmittedFilters()) == null ? void 0 : _CoreDomainSearchModu.query;
      return useInViewOnce({
        enabled: enabled && !!domain,
        threshold: IMPRESSION_THRESHOLD,
        resetKey: searchKey,
        onVisible: () => {
          var _hostModule$internals;
          const store = hostModule.SDK.suggestionImpressions;
          const key = `${domain}|${pageNumber}`;
          const _store$getStore = store.getStore(),
            reportedFor = _store$getStore.searchKey,
            reported = _store$getStore.reported;
          if (reportedFor === searchKey && reported[key]) {
            return;
          }
          store.markViewed({
            searchKey,
            key
          });
          (_hostModule$internals = hostModule.internals.bi) == null || _hostModule$internals.onSuggestionViewed == null || _hostModule$internals.onSuggestionViewed({
            domain: domain ?? '',
            position,
            pageNumber,
            isPremium
          });
        }
      });
    }
  }
}));
//# sourceMappingURL=suggestionImpressions.extension.js.map